import React, { useContext, useEffect, useState } from 'react';

import Typography from '@material-ui/core/Typography';

import AuthContext from '../../../services/firebase/AuthContext';
import FireDataContext from '../../../services/firebase/FireDataContext';
import Grid from '@material-ui/core/Grid';
import MemberQuoteCard from './MemberQuoteCard';
import MemberMiniMenu from '../menus/MemberMiniMenu';

const MemberQuotesContent = ({ quotes }) => {

    return (
        <div>
            <Typography variant="h6">Quotes</Typography>
            <Grid container spacing={1}>
                <Grid item container direction="column" xs={12} lg={4}>
                    {
                        quotes.filter(q => /draft/i.test(q.status) && !q.booking).sort((a, b) => a.ts - b.ts).map(q => {
                            return <MemberQuoteCard key={q.id} quote={q} />
                        })
                    }
                </Grid>
                <Grid item container direction="column" xs={12} lg={4}>
                    {
                        quotes.filter(q => /submitted/i.test(q.status) && !q.booking).sort((a, b) => b.ts - a.ts).map(q => {
                            return <MemberQuoteCard key={q.id} quote={q} />
                        })
                    }
                </Grid>
                <Grid item container direction="column" xs={12} lg={4}>
                    {
                        quotes.filter(q => q.booking).sort((a, b) => b.ts - a.ts).map(q => {
                            return <MemberQuoteCard key={q.id} quote={{...q, status: 'accepted'}} />
                        })
                    }
                </Grid>
            </Grid>
        </div>
    );
}

const MemberQuotesPage = () => {
    const { currentUser } = useContext(AuthContext);
    const db = useContext(FireDataContext);

    const [quotes, setQuotes] = useState();

    useEffect(() => {
        const unsubscribe = db.subscribe({ 
            path: `intermediaries/${currentUser.uid}/quotes`,
            hook: data => {
                setQuotes(data);
            }
        
        });

        return unsubscribe;

    }, [db, currentUser.uid])

    if (!quotes) return <></>;

    return (
        <MemberMiniMenu>
            <MemberQuotesContent quotes={quotes} />
        </MemberMiniMenu>
    )
};

export default MemberQuotesPage;